const blobToBase64 = (blob) => {
    if (!blob || !(blob instanceof Blob)) {
        return Promise.reject(new Error('Parâmetro deve ser um Blob válido'));
    }

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onloadend = () => {
            let base64String = reader.result;
                const parts = base64String.split(',');
                if (parts.length > 1) {
                    base64String = parts[1];
                }
            
            resolve(base64String);
        };
        reader.readAsDataURL(blob);
    });
};

export default blobToBase64;